<style scoped>
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.v-application .white {
  border: #ccd0d9 solid 1px !important;
}
</style>
<template>
  <div>
    <v-layout class="d-flex justify-space-between">
      <div class="text-h4 font-weight-black primary--text text-spacing" color="blue">เพิ่มพนักงาน</div>
      <v-spacer></v-spacer>

      <v-btn
        outlined
        color="indigo"
        style="margin-right:10px"
        elevation="0"
        dark
        link
        :to="'/manage/all-personnel'"
      >
        <v-icon left>mdi-file-cancel</v-icon>ย้อนกลับ
      </v-btn>
    
    
      <v-btn
        color="info"
        elevation="0"
        dark
        v-if="this.$store.getters['Personnel/getEdit'] == true"
        @click="update"
      >บันทึกการแก้ไข</v-btn> 
       <v-btn
        color="success"
        elevation="0"
        dark
        v-else
        @click="save"
      ><v-icon left>mdi-file-plus</v-icon>บันทึก</v-btn>

    </v-layout>
    <v-divider class="my-2"></v-divider>
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-row>
        <v-col cols="12" lg="6">
          เลขประจำตัวประชาชน :
          <v-text-field prepend-icon="mdi-badge-account-horizontal-outline" dense outlined :rules="setProso_Rules" v-model="cid"></v-text-field>
        </v-col>
        <v-col cols="12" lg="6">
          คำนำหน้าชื่อ :
          <v-select
          prepend-icon="mdi-account-box-outline"
            color="black"
            :items="nametype"
            item-text="nametype"
            :rules="setProso_Rules"
            outlined
            dense
            return-object
            v-model="setNametype"
          ></v-select>
        </v-col>
        <v-col cols="12" lg="6" class="mt-n10">
          ชื่อจริง :
          <v-text-field prepend-icon="mdi-account-box-outline" dense outlined v-model="firstname" :rules="setProso_Rules"></v-text-field>
        </v-col>
        <v-col cols="12" lg="6" class="mt-n10">
          นามสกุล :
          <v-text-field prepend-icon="mdi-account-box-outline" dense outlined v-model="lastname" :rules="setProso_Rules"></v-text-field>
        </v-col>
        <v-col cols="12" lg="12" class="mt-n10">
          ที่อยู่ :
          <v-text-field prepend-icon="mdi-home-circle" dense outlined v-model="in_address" :rules="setProso_Rules"></v-text-field>
        </v-col>
        <v-col cols="12" lg="6" class="mt-n10">
          <addressinput-subdistrict  v-model="Customer_Subdistrict" />
        </v-col>
        <v-col cols="12" lg="6" class="mt-n10">
          <addressinput-district v-model="Customer_District" />
        </v-col>
        <v-col cols="12" lg="6" class="mt-n5">
          <addressinput-province v-model="Customer_Province" />
        </v-col>
        <v-col cols="12" lg="6" class="mt-n5">
          <addressinput-zipcode v-model="Customer_Zipcode" />
        </v-col>
        <v-col cols="12" lg="6">
          เบอร์โทร :
          <v-text-field prepend-icon="mdi-card-account-phone" dense outlined v-model="phone" :rules="setProso_Rules"></v-text-field>
        </v-col>
        <v-col cols="12" lg="6">
          ตำแหน่ง :
          <v-select
          prepend-icon="mdi-book-account-outline"
            color="black"
            :items="position"
            v-model="setPosition"
            item-text="position"
            :rules="setProso_Rules"
            outlined
            dense
            return-object
          ></v-select>
        </v-col>
      </v-row>
      <v-spacer></v-spacer>
      <v-divider></v-divider>
    </v-form>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      nametype: ["นาย", "นาง", "นางสาว"],
      position: ["พนักงานขับรถ", "พนักงานเก็บขน", "พนักงานทั้งขับรถและเก็บขน"],
      setProso_Rules: [(v) => !!v || ""],
      lazy: false,
      valid: false,
    };
  },
  computed: {
    setNametype: {
      get() {
        return this.$store.getters["Personnel/PERSONNEL_NAMETYPE"];
      },
      set(value) {
        if (value) {
          this.$store.commit("Personnel/SET_PERSONNEL_NAMETYPE", value);
        }
      },
    },
    setPosition: {
      get() {
        return this.$store.getters["Personnel/PERSONNEL_POSITION"];
      },
      set(value) {
        if (value) {
          this.$store.commit("Personnel/SET_PERSONNEL_POSITION", value);
        }
      },
    },
    cid: {
      get() {
        return this.$store.getters["Personnel/PERSONNEL_CID"];
      },
      set(value) {
        if (value) {
          this.$store.commit("Personnel/SET_PERSONNEL_CID", value);
        }
      },
    },
    firstname: {
      get() {
        return this.$store.getters["Personnel/PERSONNEL_NAME"];
      },
      set(value) {
        if (value) {
          this.$store.commit("Personnel/SET_PERSONNEL_NAME", value);
        }
      },
    },
    lastname: {
      get() {
        return this.$store.getters["Personnel/PERSONNEL_LASTNAME"];
      },
      set(value) {
        if (value) {
          this.$store.commit("Personnel/SET_PERSONNEL_LASTNAME", value);
        }
      },
    },
    in_address: {
      get() {
        return this.$store.getters["Personnel/PERSONNEL_ADDRESS"];
      },
      set(value) {
        if (value) {
          this.$store.commit("Personnel/SET_PERSONNEL_ADDRESS", value);
        }
      },
    },
    phone: {
      get() {
        return this.$store.getters["Personnel/PERSONNEL_PHONE"];
      },
      set(value) {
        if (value) {
          this.$store.commit("Personnel/SET_PERSONNEL_PHONE", value);
        }
      },
    },
    Customer_Zipcode: {
      get() {
        return this.$store.getters["Personnel/PERSONNEL_ZIPCODE"];
      },
      set(value) {
        if (value) {
          this.$store.commit("Personnel/SET_PERSONNEL_ZIPCODE", value);
        }
      },
    },
    Customer_Province: {
      get() {
        return this.$store.getters["Personnel/PERSONNEL_PROVINCE"];
      },
      set(value) {
        if (value) {
          this.$store.commit("Personnel/SET_PERSONNEL_PROVINCE", value);
        }
      },
    },
    Customer_District: {
      get() {
        return this.$store.getters["Personnel/PERSONNEL_DISTRICT"];
      },
      set(value) {
        if (value) {
          this.$store.commit("Personnel/SET_PERSONNEL_DISTRICT", value);
        }
      },
    },
    Customer_Subdistrict: {
      get() {
        return this.$store.getters["Personnel/PERSONNEL_SUBDISTRICT"];
      },
      set(value) {
        if (value) {
          this.$store.commit("Personnel/SET_PERSONNEL_SUBDISTRICT", value);
        }
      },
    },

  },
  methods: {
    save() {
      let Insert_person = {
        PERSONNEL_CID: this.cid,
        PERSONNEL_NAMETYPE: this.setNametype,
        PERSONNEL_NAME: this.firstname,
        PERSONNEL_LASTNAME: this.lastname,
        PERSONNEL_ADDRESS: this.in_address,
        PERSONNEL_PHONE: this.phone,
        PERSONNEL_POSITION: this.setPosition,
        PERSONNEL_SUBDISTRICT: this.Customer_Subdistrict,
        PERSONNEL_DISTRICT: this.Customer_District,
        PERSONNEL_PROVINCE: this.Customer_Province,
        PERSONNEL_ZIPCODE: this.Customer_Zipcode,
      };
   
      if (this.$refs.form.validate()) {
        this.$token_api
          .post("/insert-Personnel", Insert_person)
          .then((response) => {
            //console.log(response);
            this.$swal("บันทึกสำเร็จ", "สำเร็จ", "success");
            this.$emit("closeDi");
            this.$emit("refreshData");
            this.$refs.form.reset();
            this.$store.dispatch("Personnel/preson_reset");
          })
          .catch((err) => {});
      } else {
        this.$swal(
          "กรุณากรอกข้อมูลให้ถูกต้องครบถ้วน",
          "เกิดข้อผิดพลาด",
          "error"
        );
      }
    },
    update() {
      //console.log("saveupdate active !!!!!");
      let Update_person = {
        PERSONNEL_CID: this.cid,
        PERSONNEL_NAMETYPE: this.setNametype,
        PERSONNEL_NAME: this.firstname,
        PERSONNEL_LASTNAME: this.lastname,
        PERSONNEL_ADDRESS: this.in_address,
        PERSONNEL_PHONE: this.phone,
        PERSONNEL_POSITION: this.setPosition,
        PERSONNEL_ADDRESS: this.in_address,
        PERSONNEL_SUBDISTRICT: this.Customer_Subdistrict,
        PERSONNEL_DISTRICT: this.Customer_District,
        PERSONNEL_PROVINCE: this.Customer_Province,
        PERSONNEL_ZIPCODE: this.Customer_Zipcode,
        PERSONNEL_ID: this.$store.getters["Presonel/PERSONNEL_ID"],
      };
     
      if (this.$refs.form.validate()) {
        this.$token_api
          .post("/update-Personnel", Update_person)
          .then((response) => {
            // console.log(response.data);
            this.$swal("บันทึกสำเร็จ", "สำเร็จ", "success");
            this.$emit("closeDi");
            this.$emit("refreshData");
            this.$refs.form.reset();
            this.$store.dispatch("Personnel/preson_reset");
          })
          .catch((err) => {});
      } else {
        this.$swal(
          "กรุณากรอกข้อมูลให้ถูกต้องครบถ้วน",
          "เกิดข้อผิดพลาด",
          "error"
        );
      }
    },
    close() {
      this.$emit("closeDi");
      this.$emit("refreshData");
      this.$refs.form.reset();
      this.$store.dispatch("Personnel/preson_reset");
    },
  },
};
</script>